/**
 * Переводит список строковых ключей bitmask-enum'а в числовую маску.
 * Неизвестные ключи и значения-нули (вроде `Unexpected = 0`) игнорируются,
 * чтобы не ломать семантику «пустой список = любой тип».
 */
export function keysToBitmask<TEnum extends Record<string, number | string>>(
  enumObject: TEnum,
  keys: readonly (keyof TEnum)[] | undefined,
): number {
  if (!keys || keys.length === 0) {
    return 0;
  }

  return keys.reduce<number>((acc, key) => {
    const value = enumObject[key];

    if (typeof value !== 'number' || value === 0) {
      if (process.env.NODE_ENV !== 'production') {
        // oxlint-disable-next-line no-console
        console.warn(`[keysToBitmask] Unknown or zero-valued enum key: ${String(key)}`);
      }

      return acc;
    }

    return acc | value;
  }, 0);
}
